import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { devServer } from './globals';

if (!devServer) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

if (window.location.hostname === 'developers.vendasta.com') {
  window.location.hostname = 'vendors.vendasta.com';
}
